import { combineReducers } from 'redux';

import SigninReducer from './landing section/SigninReducer';
import SignupReducer from './landing section/SignupReducer';
import ResetPasswordReducer from './landing section/ResetPasswordReducer';
import ActicationCodeReducer from './landing section/ActivationReducer';
import CountriesReducer from './landing section/CountriesReducer';
import ProfileReducer from './landing section/ProfileReducer';
import NotificationsReducer from './landing section/NotificationsReducer';
import ConfigsReducer from './landing section/ConfigsReducer';

// Admin
import ExplanationsListReducer from './admin section/ExplanationsListReducer';

// User
import UserExamReducer from './user section/ExamReducer';
import UserCoursesReducer from './user section/CoursesReducer';
import UserSubscriptionsReducer from './user section/SubscriptionsReducer';
import UserExamsLogReducer from './user section/ExamsLogReducer';

export default combineReducers({
    configs: ConfigsReducer,
    auth: SigninReducer,
    signup: SignupReducer,
    resetPassword: ResetPasswordReducer,
    activation: ActicationCodeReducer,
    countries: CountriesReducer,
    profile: ProfileReducer,
    notifications: NotificationsReducer,

    adminExplanationsList: ExplanationsListReducer,

    userExam: UserExamReducer,
    userCourses: UserCoursesReducer,
    userSubscriptions: UserSubscriptionsReducer,
    userExamsLog: UserExamsLogReducer,
});
